export default __webpack_public_path__ + "static/media/header_webshop_1440x500px_Betriebsbuecher.634d4f6d.jpg";